export default __webpack_public_path__ + "static/consultingBlogImage-356ecd71d76091c7c32d6b18ee0ef3f1.png";